import { createReducer } from '@reduxjs/toolkit'

import type { TSavedDashboardFilterDto } from '@homepal/api-contract'

import { insertItems, removeItem, upsertItem } from 'redux/utils'

import * as actions from '../../actions/SavedDashboardFilters/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface SavedDashboardFilterReducerType {
  data: Record<string, TSavedDashboardFilterDto>
  fetched: boolean
  fetching: boolean
}

// Initial state
const INITIAL_STATE: SavedDashboardFilterReducerType = {
  data: {},
  fetched: false,
  fetching: false
}

// Reducer (createReducer uses immer — cases mutate the draft directly)
export default createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAll, (state) => {
      state.fetched = false
      state.fetching = true
    })
    .addCase(actions.getAllSuccess, (state, action) => {
      state.data = insertItems(action.payload)
      state.fetched = true
      state.fetching = false
    })
    .addCase(actions.getAllFailed, (state) => {
      state.data = {}
      state.fetched = true
      state.fetching = false
    })
    .addCase(actions.createSuccess, (state, action) => {
      state.data = upsertItem(state.data, action.payload)
    })
    .addCase(actions.updateSuccess, (state, action) => {
      state.data = upsertItem(state.data, action.payload)
    })
    .addCase(actions.destroySuccess, (state, action) => {
      state.data = removeItem(state.data, action.payload)
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
})
